import React, { Component } from 'react'
import { Alert } from 'reactstrap'
class InternalServerError extends Component {
  render () {
    return (
      <React.Fragment>
        <Alert color='danger'>
          <h3 style={{ fontWeight: 300, padding: '1% 0' }}>
            <center>
              Internal Server Error
              &nbsp;
            </center>
          </h3>
        </Alert>
      </React.Fragment>
    )
  }
}
export default InternalServerError
